import { getFullComponentLabel } from '@ardoq/graph';
import { COMPONENT_HIERARCHY_PADDING } from '../consts';
import { ComponentMatrixGroup, ComponentMatrixGroupOwnerType } from '../types';

const labelFromAddressToken = (
  token: string | null,
  ownerType: ComponentMatrixGroupOwnerType,
  componentLabelById: Record<string, string> | undefined
): string => {
  if (token === null) {
    // LIST_FIELD_VALUE "no value" token — consumer sites render
    // NONE_HEADER_LABEL when the label is empty.
    return '';
  }
  if (ownerType !== ComponentMatrixGroupOwnerType.REFERENCED_COMPONENT) {
    return token;
  }
  if (token === COMPONENT_HIERARCHY_PADDING) {
    return token;
  }
  if (componentLabelById) {
    return componentLabelById[token] ?? '';
  }
  return getFullComponentLabel(token);
};

/** When `componentLabelById` is supplied, REFERENCED_COMPONENT tokens are
 * labeled from the pre-resolved map (viewpoint-mode CM2 builds this from
 * `labelsInterface.getComponentDisplayName`). Without it, the legacy
 * `getFullComponentLabel` formatter is used — which legacy workspace mode still
 * relies on. ARD-32168. */
export const addAddressToGroup = (
  address: (string | null)[],
  ownerTypes: ComponentMatrixGroupOwnerType[],
  groupMap: Map<string | null, ComponentMatrixGroup>,
  componentLabelById?: Record<string, string>
) => {
  if (!address.length) {
    return;
  }

  let currentGroup: ComponentMatrixGroup =
    groupMap.get(address[0]) ||
    groupMap
      .set(address[0], {
        address: [address[0]],
        label: labelFromAddressToken(
          address[0],
          ownerTypes[0],
          componentLabelById
        ),
        children: new Map(),
        ownerType: ownerTypes[0],
        isExpanded: false,
        isHidden: false,
        otherLabels: [],
      })
      .get(address[0])!;

  address.slice(1).forEach((token, index) => {
    const ownerType = ownerTypes[1 + index];
    currentGroup =
      currentGroup.children.get(token) ||
      currentGroup.children
        .set(token, {
          address: address.slice(0, index + 2),
          label: labelFromAddressToken(token, ownerType, componentLabelById),
          children: new Map(),
          ownerType,
          isExpanded: false,
          isHidden: true,
          otherLabels: [],
        })
        .get(token)!;
  });
};
